// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Chip_wrap__1bDQb","remove-icon":"Chip_remove-icon__1SQ23","divider":"Chip_divider__26OR6"};